import React from 'react';

import {
  DescriptionList,
  DescriptionItem,
  Typography,
  Help,
  Grid,
  Section,
} from '@gogame/components';

const General = ({ data }) => {
  return (
    <Section title={'General'}>
      <DescriptionList stripEmpty={true} data={data} disableGutters={true}>
        <DescriptionItem label={'Size'} field={'size'} type={'decimal'} />
        <DescriptionItem label={'Partner'} field={'partner.name'} />
        <DescriptionItem label={'Partner list ID'} field={'partnerApiId'} />
        <DescriptionItem label={'Data type'} field={'dataType.name'} />
        <DescriptionItem label={'Type'} field={'partnerData.type'} />
        <DescriptionItem
          label={'Description'}
          field={'partnerData.description'}
        />
        {data?.includeValues && (
          <DescriptionItem
            label={'Partner Options'}
            field={'includeValues'}
            type={() => {
              return (
                <Grid container>
                  <Grid
                    item
                    container
                    xs={12}
                    spacing={1}
                    alignItems={'center'}
                  >
                    <Grid item>
                      <Typography>- Include values</Typography>
                    </Grid>
                    <Grid item>
                      <Help placement={'right'}>
                        For more accurate Facebook Lookalike audiences
                      </Help>
                    </Grid>
                  </Grid>
                  {data.hasOwnProperty('partnerData') &&
                  data?.partnerData?.powerMultiply ? (
                    <Grid
                      item
                      container
                      xs={12}
                      spacing={1}
                      alignItems={'center'}
                    >
                      <Grid item>
                        <Typography>- Multiply deposits amount</Typography>
                      </Grid>
                      <Grid item>
                        <Help placement={'right'}>
                          For better understanding for depositors significance
                        </Help>
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
              );
            }}
          />
        )}

        <DescriptionItem label={'Credentials'} field={'credentials.name'} />
        <DescriptionItem
          label={'Account'}
          field={'account'}
          type={({ value: { id, name } }) => {
            return (
              <Grid direction={'column'} container>
                <Typography data-cy-role={'descriptionValue'}>
                  {name}
                </Typography>
                <Typography
                  variant={'caption'}
                  intensity={200}
                  data-cy-role={'descriptionValue'}
                >
                  ID {id}
                </Typography>
              </Grid>
            );
          }}
        />
        <DescriptionItem
          label={'Relevant Users'}
          field={'syncFailNotificationRecipients'}
          type={'typographyList'}
          limit={1}
          listType={'bullet'}
          unitsLabel={'users'}
        />
      </DescriptionList>
    </Section>
  );
};

export default General;
